import React from 'react';
import JudgeScoringPageRotation from './JudgeScoringPageRotation';

export default function RangeScoring() {
  return <JudgeScoringPageRotation apparatus="range" />;
}
